export const bigNumAsInt = (num) => parseInt(num.toString());
